export enum TAB_VALUES {
    All = "3",
    PendingApproval = "1",
    AlreadyApproved = "2",
    NoApprovalRequired = "0"
}
